import PageHero from '@/components/feature/PageHero';
import { evidenceHero } from '@/mocks/evidence';

export default function Hero() {
  return (
    <PageHero
      eyebrow={evidenceHero.eyebrow}
      title={evidenceHero.title}
      titleHighlight={evidenceHero.titleHighlight}
      subtitle={evidenceHero.subtitle}
      desc={evidenceHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Secure%20digital%20evidence%20and%20certification%20center%20with%20glowing%20verified%20documents%2C%20technology%20achievements%20and%20realtime%20data%20dashboards%20floating%20in%20dark%20space%2C%20deep%20navy%20ink%20background%2C%20eco%20green%20and%20gold%20seal%20accents%2C%20national%20strategy%20technology%20aesthetic%2C%20cinematic%20soft%20lighting&width=1800&height=1200&seq=evidence-hero-01&orientation=landscape"
      imageAlt="九畴云市证据中心 资质文件技术生态数据"
      imageTitle="九畴云市 证据中心"
    />
  );
}